export default __webpack_public_path__ + "static/media/fad-digital6.7a1a5da8.svg";